export const NOTE_DEFAULT_MAX_LENGTH = 500;
export const NOTE_SUPSHIP_MAX_LENGTH = 100;
